<template>
  <div class="flex-row-nowrap-start-start-baseline">
    <div class="field-title" :style="titleStyle">{{ title }}</div>
    <div class="field-value">{{ value }}</div>
  </div>
</template>
<script lang="ts" setup>
import { watch, computed } from "vue"

const props = defineProps<{
  title: string
  value: string
  titleWidth?: number
}>()

const titleStyle = computed(() => {
  if (props.titleWidth) {
    return {
      width: `${props.titleWidth}px`,
    }
  } else {
    return {}
  }
})
</script>
<style scoped>
.field-title {
  flex-shrink: 0;
  font-size: 16px;
  color: #999;
  margin-right: 8px;
}

.field-value {
  flex-shrink: 0;
  font-size: 16px;
  color: #333;
}
</style>
